module.exports = __webpack_public_path__ + "img/1.eced9a5e.svg";